import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'store';
import { SearchForm } from 'components/common';

const GroupsSearch = connect((state) => state)(
  class extends Component {
    handleClear = async () => {
      await this.props.updateGroups({ page: 1, search: '' });
    };

    handleError = async (err) => {
      const { dispatch } = this.props;
      dispatch(actions.updatePageState({ loading: false }));
      await dispatch.handleErrorDispatch(err);
    };

    handleSearch = async (value) => {
      await this.props.updateGroups({
        page: 1,
        search: value,
        throwError: true
      });
    };

    render() {
      const { messages } = this.props;

      return (
        <SearchForm
          placeholderText={messages.groupsSearch}
          onClear={this.handleClear}
          onError={this.handleError}
          onSearch={this.handleSearch}
        />
      );
    }
  }
);

export default GroupsSearch;
